export default __webpack_public_path__ + "static/media/Blake.8541cf54.jpg";